import React from "react";
// import Map from "./map/App";

export default function KiranaMap() {
  return <>{/* <Map /> */}</>;
}
